import { render, staticRenderFns } from "./RawLeads.vue?vue&type=template&id=f72294a0&scoped=true"
import script from "./RawLeads.vue?vue&type=script&lang=js"
export * from "./RawLeads.vue?vue&type=script&lang=js"
import style0 from "./RawLeads.vue?vue&type=style&index=0&id=f72294a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72294a0",
  null
  
)

export default component.exports